import React, { useEffect, useRef, useState } from "react";
import { Table, Button } from "react-bootstrap";
import ToastFile from "../../utils/ToastFile";
import Layout from "../../components/Layout";
import { useNavigate } from "react-router-dom";
import { MdDelete, MdModeEdit, MdPerson } from "react-icons/md";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import { deleteEmployeeByID, getAllEmployeebyContractor } from "../../api/EmployeeApi";
import moment from "moment";
import DeleteModel from "../../components/DeleteModel";
import Loader from "../../components/Loader";

const Employee = () => {
  const [employees, setEmployees] = useState([]);
  const navigate = useNavigate();
  const [isPasswordVisible, setIsPasswordVisible] = useState({});
  const fetched = useRef(false);
  const user = JSON.parse(localStorage.getItem("user"));
  const [deleteModal, setDeleteModal] = useState(false)
  const [deleteIndex, setDeleteIndex] = useState(0);
  const [isLoading, setIsloading] = useState(true)

  useEffect(() => {
    if (fetched.current) return;
    fetched.current = true;
    getEmployee();
  }, []);

  const togglePasswordVisibility = (id) => {
    setIsPasswordVisible((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  const getEmployee = () => {
    setIsloading(true)
    getAllEmployeebyContractor(user.tenant_id)
      .then((res) => {
        if (res.status === 200) {
          setEmployees(res?.data?.data?.employees);
        } else {
          ToastFile("Failed to fetch employees", "error");
        }
      })
      .catch((err) => {
        console.error("Error fetching employees:", err);
        ToastFile("Error fetching employees", "error");
      })
      .finally(()=>{
        setIsloading(false)
      })
  };

  const openAddModal = () => {
    navigate("/employees/add");
  };

  const openEditModal = (index) => {
    let employee = employees[index];
    employee.license_exp_date = employee.license_exp_date
      ? moment(employee.license_exp_date).format("YYYY-MM-DD")
      : null;
    navigate("/employees/edit", {
      replace: true,
      state: { employee },
    });
  };

  const deleteEmployee = () => {
    deleteEmployeeByID(employees[deleteIndex]._id)
      .then((res) => {
        if (res.status === 200) {
          ToastFile("Employee deleted", "deleted");
          fetched.current = false;
          getEmployee();
        } else {
          ToastFile("Failed to delete employee", "error");
        }
      })
      .catch((err) => {
        console.error("Error deleting employee:", err);
        ToastFile("Error deleting employee", "error");
      })
      .finally(()=>{
        setDeleteIndex(0)
        setDeleteModal(false)
      })

  };

  return (
    <Layout>
      <DeleteModel showModal={deleteModal} setShowModal={setDeleteModal} onYes={deleteEmployee}/>
      {/* Header Section - Mobile Responsive */}
      <div className="d-flex flex-column flex-md-row justify-content-between align-items-start align-items-md-center mb-3 gap-3">
        <h3 className="mb-0">Employee Management</h3>
        <Button onClick={openAddModal} className="bg-dark">
          + Add Employee
        </Button>
      </div>

      {/* Table Section - Mobile Responsive */}
      <div className="table-responsive d-none d-md-block">
        <Table striped bordered hover className="table-sm">
          <thead className="table-dark">
            <tr style={{ textAlign:'center' }}>
              <th className="text-nowrap">Name</th>
              <th className="text-nowrap d-none d-lg-table-cell">Email</th>
              <th className="text-nowrap d-none d-xl-table-cell">Password</th>
              <th className="text-nowrap d-none d-lg-table-cell">Contact no</th>
              <th className="text-nowrap d-none d-xl-table-cell">Address</th>
              <th className="text-nowrap d-none d-xl-table-cell">ABN</th>
              {/* <th className="text-nowrap d-none d-xl-table-cell">License No</th> */}
              <th className="text-nowrap d-none d-xl-table-cell">Driving License Exp Date</th>
              <th className="text-nowrap d-none d-lg-table-cell">Designation</th>
              {/* <th className="text-nowrap d-none d-lg-table-cell">Pay Rate</th> */}
              <th className="text-nowrap">Status</th>
              <th className="text-nowrap">Actions</th>
            </tr>
          </thead>
          {isLoading ? <tbody>
              <tr>
                <td colSpan="11">
                  <Loader/>
                </td>
              </tr>
            </tbody>
            :
          <tbody>
            {employees.length === 0 ? (
              <tr>
                <td colSpan="11" className="text-center">
                  No employees found
                </td>
              </tr>
            ) : (
              employees.map((e, idx) => (
                <tr key={idx}>
                  <td className="">
                    <div className="fw-bold">{e.name}</div>
                    <small className="text-muted d-md-none">
                      {e.email} • {e.contact_no}
                    </small>
                  </td>
                  <td className="d-none d-lg-table-cell">{e.email}</td>
                  <td className="d-none d-xl-table-cell">
                    <div className="d-flex justify-content-between align-items-center">
                      {isPasswordVisible[idx]
                        ? e.password
                        : "*".repeat(e.password.length)}
                      <button
                        className="border-0 bg-transparent"
                        onClick={() => togglePasswordVisibility(idx)}
                      >
                        {isPasswordVisible[idx] ? <FaEyeSlash size={14} /> : <FaEye size={14} />}
                      </button>
                    </div>
                  </td>
                  <td className="d-none d-lg-table-cell">{e.contact_no}</td>
                  <td className="d-none d-xl-table-cell">{e.address}</td>
                  <td className="d-none d-xl-table-cell">{e.abn}</td>
                  {/* <td className="text-nowrap d-none d-xl-table-cell">{e.license_no}</td> */}
                  <td className="d-none d-xl-table-cell" style={{textAlign: 'center'}}>{e.license_exp_date && moment(e.license_exp_date).format("DD-MM-YYYY")}</td>
                  <td className="d-none d-lg-table-cell">{e.designation}</td>
                  {/* <td className="text-nowrap d-none d-lg-table-cell">{e.payrate}</td> */}
                  <td className="text-nowrap">
                    {e.status === "Active" ? (
                      <span className="badge bg-success">{e.status}</span>
                    ) : (
                      <span className="badge bg-danger">{e.status}</span>
                    )}
                  </td>
                  <td className="text-nowrap">
                    <div className="d-flex gap-1">
                      <button
                        className="btn btn-sm btn-outline-primary border-0"
                        onClick={() => openEditModal(idx)}
                        title="Edit"
                      >
                        <MdModeEdit size={16} />
                      </button>
                      <button
                        className="btn btn-sm btn-outline-danger border-0"
                        onClick={() => {setDeleteIndex(idx); setDeleteModal(true)}}
                        title="Delete"
                      >
                        <MdDelete size={16} />
                      </button>
                    </div>
                  </td>
                </tr>
              ))
            )}
          </tbody>}
        </Table>
      </div>

      {/* Mobile Card View for Small Screens */}
      <div className="d-md-none">
        {employees.length === 0 ? (
          <div className="text-center py-4">
            <p className="text-muted">No employees found</p>
          </div>
        ) : (
          <div className="row g-3">
            {employees.map((e, idx) => (
              <div key={idx} className="col-12">
                <div className="card">
                  <div className="card-body">
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div className="flex-grow-1">
                        <h6 className="card-title mb-1">{e.name}</h6>
                        <small className="text-muted d-block">{e.email}</small>
                        <small className="text-muted">{e.contact_no}</small>
                      </div>
                      <div className="text-end">
                        <div className="mb-2">
                          {e.status === "Active" ? (
                            <span className="badge bg-success">{e.status}</span>
                          ) : (
                            <span className="badge bg-danger">{e.status}</span>
                          )}
                        </div>
                        <div className="d-flex gap-1">
                          <button
                            className="btn btn-sm btn-outline-primary"
                            onClick={() => openEditModal(idx)}
                            title="Edit"
                          >
                            <MdModeEdit size={16} />
                          </button>
                          <button
                            className="btn btn-sm btn-outline-danger"
                            onClick={() => {setDeleteIndex(idx); setDeleteModal(true)}}
                            title="Delete"
                          >
                            <MdDelete size={16} />
                          </button>
                        </div>
                      </div>
                    </div>
                    
                    <div className="row g-2 mb-3">
                      <div className="col-6">
                        <small className="text-muted d-block">Designation</small>
                        <span>{e.designation}</span>
                      </div>
                      {/* <div className="col-6">
                        <small className="text-muted d-block">Pay Rate</small>
                        <span>${e.payrate}</span>
                      </div> */}
                      <div className="col-6">
                        <small className="text-muted d-block">ABN</small>
                        <span>{e.abn || "N/A"}</span>
                      </div>
                      <div className="col-6">
                        <small className="text-muted d-block">Driving License Exp. No</small>
                        <span>{e.license_exp_date && moment(e.license_exp_date).format("DD-MM-YYYY")}</span>
                      </div>
                    </div>

                    <div className="mb-2">
                      <small className="text-muted d-block">Address</small>
                      <span className="small">{e.address || "N/A"}</span>
                    </div>

                    <div className="d-flex justify-content-between align-items-center">
                      <small className="text-muted">Password</small>
                      <div className="d-flex align-items-center gap-2">
                        <span className="small">
                          {isPasswordVisible[idx]
                            ? e.password
                            : "*".repeat(e.password.length)}
                        </span>
                        <button
                          className="btn btn-sm btn-outline-secondary border-0"
                          onClick={() => togglePasswordVisibility(idx)}
                        >
                          {isPasswordVisible[idx] ? <FaEyeSlash size={14} /> : <FaEye size={14} />}
                        </button>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        )}
      </div>
    </Layout>
  );
};

export default Employee;
